// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"2679b305","127":"e24795e1","168":"bda8e466","261":"fbffc991","428":"4891c956","439":"aed7a333","453":"3a87ce39","501":"f1dd67ea","534":"143658f5","546":"380b3bf1","791":"2aa67285","830":"7a402db6","972":"eb0293b3","993":"db690bea"}[chunkId] + ".chunk.js";
};